import {
  formatSandStockAvailability,
  stockQuantityToTonnes,
  tonnesPerLorry,
} from '../constants/sandLorryCapacity';

/** Match backend resolution: explicit pick → type link → first matching material. */
export function resolveMaterialProduct(materials, preferredPool, explicitId, linkedId) {
  const primary = materials?.length ? materials : preferredPool;
  if (!primary?.length && !preferredPool?.length) return null;

  if (explicitId) {
    return (
      primary.find((p) => String(p.id) === String(explicitId))
      ?? preferredPool?.find((p) => String(p.id) === String(explicitId))
      ?? null
    );
  }
  if (linkedId) {
    const linked =
      primary.find((p) => String(p.id) === String(linkedId))
      ?? preferredPool?.find((p) => String(p.id) === String(linkedId));
    if (linked) return linked;
    // Stale type link (e.g. sample/orphan product) — fall back like the API does.
  }
  return preferredPool?.[0] ?? null;
}

export function validateStockUsage(requested, product, materialLabel) {
  const qty = Number(requested) || 0;
  if (qty <= 0) return null;
  if (!product) {
    return `Hakuna ${materialLabel} kwenye stock. Ongeza chini ya Raw materials.`;
  }
  const available = Number(product.quantity) || 0;
  const unit = product.unit || 'pcs';
  if (qty > available) {
    return `${materialLabel} (${qty}) inazidi stock iliyopo (${available} ${unit} — ${product.name}).`;
  }
  return null;
}

export function formatStockLine(product) {
  if (!product) return null;
  const unit = product.unit || 'pcs';
  return `${product.name}: ${product.quantity} ${unit} kwenye stock`;
}

/** Sand usage is always in tonnes — compare against stock (lori/kg/tone converted). */
export function validateSandTonnesUsage(tonnesNeeded, product, configTonnesPerLorry) {
  const needed = Number(tonnesNeeded) || 0;
  if (needed <= 0) return null;
  if (!product) {
    return 'Hakuna mchanga kwenye stock. Ongeza chini ya Raw materials.';
  }
  const tPerLorry = tonnesPerLorry(configTonnesPerLorry);
  const available = stockQuantityToTonnes(product.quantity, product.unit, tPerLorry);
  if (needed > available + 0.0005) {
    const stockLine = formatSandStockAvailability(product, tPerLorry);
    return `Mchanga unahitaji ${needed} tone lakini stock ni ${stockLine}.`;
  }
  return null;
}
